import React, { useState } from "react";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import GalleryLightbox from './gallery';
import Gallery from 'react-grid-gallery';
import { createGalleryImageObjects, createGalleryPreview } from "../../util";
import ModalEdit from "./modalEdit";
import filesService from '../../services/file.service';
import ModalMap from "./modalMap";
import { sourceUrl } from '../../environment';
import { toastOptions } from '../shared/selectStyle';
import ModalYesNo from "../shared/modalYesNo";
const modalText = "Are you sure you want to delete this image?";
const modalHeading = "Delete";

const PREVIEW_MAX_IMAGES = 2

const Files = (props) => {
    const { t } = useTranslation();
    const [index, setIndex] = useState(null);
    const [activeDate, setActiveDate] = useState(null);
    const [showGalery, setShowGalery] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    
    const [showModalMap, setShowModalMap] = useState(false);
    const [fileData, setFileData] = useState({
        description: '',
        address: '',
        _id: ''
    });
    const [cordinates, setCordinates] = useState([]);
    const [address, setAddress] = useState('');
    const [gallery, setGallery] = useState([]);

    const openLightbox = (listFiles, i, e) => {
        var images = [];

        listFiles.forEach(element => {
            images = images.concat(createGalleryImageObjects(element, true))
        });
        setGallery(images);
        setShowGalery(true);
    }

    const closeGallery = () => {
        setShowGalery(false);
    }
    const openModalEdit = async (file, index) => {
        setIndex(index);
        setActiveDate(file.folder)
        setShowModal(true);
        setFileData({
            description: file.desc,
            address: file.address,
            _id: file._id
        });
    }
    const closeModal = async () => {
        setShowModal(false);
        setShowModalMap(false);
        setShowModalDelete(false);
    }
    const openModalMap = async (file) => {
        setCordinates(file.location);
        setAddress(file.address)
        setShowModalMap(true);
    }
    const updateLocation = async (folder) => {
        const response = await filesService.updateLocationAndDesc(folder);
        if (response) {
            props.isChanged(activeDate, index);
            closeModal();
            toast.success("Data successfully updated!", toastOptions);
        } else {
            toast.error("Invalid address!", toastOptions);
        }
    }
    const openYesNoModal = (file) =>{
        setShowModalDelete(true);
        setFileData({...file})
    }
    const handleYesNoAnswer= (answer)=>{
        if(answer === 'yes'){
            props.delete(fileData._id, props.list)
            closeModal();
        } else{
            closeModal();
        }
    }

    const printLocation = (location) => {
      if (!location) return ''
      return location[1] + ', ' + location[0]
    }

    return (
        <div className="files-preview">
            <h4 className="h4-title">{t('files.title')}</h4>
            <ul className="images-box">
                {props.list.map((file, i) =>
                    <li className='image-preview' id={file._id} key={i}>
                        <div className="image-frame" onClick={(e) => { openLightbox(props.list, i, e) }} >
                            {/*<img src={sourceUrl + file._id + '.' + file.ext} alt={""} />*/}
                            <Gallery
                              images={createGalleryPreview(file.images ? file.images: [file._id], PREVIEW_MAX_IMAGES)}
                            />
                            {file.images.length > PREVIEW_MAX_IMAGES ? <span className="image-count">+{file.images.length-PREVIEW_MAX_IMAGES}</span> : null}
                        </div>
                        <div className="image-desc">
                            <div>
                                <div>
                                    <img  src={file.avatarId ? `${sourceUrl}${file.avatarId}.${file.avatarExt}?t=' + ${new Date().getTime()}` : `/assets/images/avatar.png`} alt={file.username} />
                                    <span>{file.username}</span>
                                </div>
                                <i className="fa fa-trash" aria-hidden="true" onClick={() => {openYesNoModal(file) }} ></i>
                            </div>
                            <div className="image-location">
                                <img  src="/assets/images/location.svg" alt="Location" onClick={() => { openModalMap(file) }} />
                                <h6 className="c-blue ">{file.address}</h6>
                                <i className="fa fa-pencil" aria-hidden="true" onClick={() => { openModalEdit(file, i) }} ></i>
                            </div>
                            <span>{printLocation(file.location)}</span>
                            <p className="text-desc">{file.desc} </p>
                        </div>
                    </li>
                )}
            </ul>
            {showModalDelete ?<ModalYesNo heading={modalHeading} text={modalText} show={showModalDelete} closeModal={closeModal} handleYesNoAnswer={handleYesNoAnswer}/> :null}
            {showModal ? <ModalEdit show={showModal} closeModal={closeModal} fileData={fileData} updateLocation={updateLocation} /> : null}
            {showModalMap ? <ModalMap show={showModalMap} closeModal={closeModal} cordinates={cordinates} address={address} /> : null}
            <GalleryLightbox images={gallery} close={closeGallery} isOpen={showGalery} />
        </div>
    );
}

export default Files;



// WEBPACK FOOTER //
// ./src/components/foldersComponent/files.js